/** Shopify CDN: Minification failed

Line 37:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 19:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 21:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 7:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 9:0 Transforming const to the configured target environment ("es5") is not supported yet

**/
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
